import React from 'react';

import { theme } from '../../../../tailwind.config';
import { IIconProps } from 'ui/CircleIconButton';

export const DoubleCheckIcon: React.FC<IIconProps> = React.memo(
  ({ fill = theme.colors['light-gray'], width = 16, height = 16 }) => (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8268 3.72665L7.77344 10.78L4.98677 7.99999L4.04677 8.93999L7.77344 12.6667L15.7734 4.66665L14.8268 3.72665ZM12.0001 4.66665L11.0601 3.72665L6.83344 7.95332L7.77344 8.89332L12.0001 4.66665ZM4.0001 12.6667L0.273438 8.93999L1.2201 7.99999L4.9401 11.7267L4.0001 12.6667Z"
        fill={fill}
      />
    </svg>
  )
);
